import styled from "styled-components";

export const AppShell = styled.div`
  height: 100vh; /* fallback */
  height: 100dvh; /* iOS 16+ dynamic viewport */
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;
